"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MultiProgressCircle = _interopRequireDefault(require("../../MultiProgressCircle"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var ItemIcon = function ItemIcon(_ref) {
  var status = _ref.status,
      progress = _ref.progress;

  if (status === 'loading') {
    return _react.default.createElement("div", null, _react.default.createElement(_MultiProgressCircle.default, {
      size: 14,
      strokeWidth: 14,
      sections: [{
        color: '#3498db',
        progress: progress
      }],
      className: "IconLoading",
      key: "1"
    }), _react.default.createElement(_Icon.default, {
      type: "close",
      key: "2"
    }));
  }

  return _react.default.createElement(_Icon.default, {
    type: status
  });
};

ItemIcon.defaultProps = {
  progress: 0
};
ItemIcon.propTypes = {
  status: _propTypes.default.oneOf(['success', 'restart', 'loading']).isRequired,
  progress: _propTypes.default.number
};
var _default = ItemIcon;
exports.default = _default;